<div class="general-container" [ngClass]="{'!p-6':bp.isCompact()}">
  <img
    class="image-svg image-1"
    src="assets/img/login/lines.svg"
    alt="Login lines migo"
  />
  <img
    class="image-svg image-2"
    src="assets/img/login/rafiki.svg"
    alt="Login lines migo"
  />
  <div class="migo-logo-container">
    <img src="assets/img/login/migo-iso.svg" alt="migo logo" />
    <img src="assets/img/login/migo-logo.svg" alt="migo logo" />
  </div>
  <span class="slogan-text"
    >Simplifica el control de las transacciones de tu negocio. Pagos exitosos,
    clientes satisfechos.</span
  >
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>

  <img
    class="image-svg image-3"
    src="assets/img/login/lines-2.svg"
    alt="Login lines migo"
  />
</div>
